import * as types from "./actionTypes"

const initialState = {
    orders: [],
    firstOrder: {},
    allTracks: [],
    saveCarOrderQualityResponse: [],
    patterns: [],
}

export default function carOrdersReducer(state = initialState, action) {
    switch (action.type) {
        case types.CAR_ORDER_DATA_SUCCESS:
            return {
                ...state,
                orders: action.payload.CarOrderDetails
                    ? action.payload.CarOrderDetails.sort((a, b) => {
                          return new Date(b.DateWanted) - new Date(a.DateWanted)
                      })
                    : [],
                firstOrder: action.payload.CarOrderDetails
                    ? action.payload.CarOrderDetails.sort((a, b) => {
                          return new Date(b.DateWanted) - new Date(a.DateWanted)
                      })[0]
                    : {},
                patterns: action.payload.carOrderPatterns,
            }

        case types.CAR_ORDER_PATTERNS_DATA_SUCCESS:
            return {
                ...state,
                patterns: action.payload,
            }

        case types.SHIPPER_TRACKS_DATA_SUCCESS:
            return {
                ...state,
                allTracks: action.payload.Tracks,
            }

        case types.SAVE_CAR_ORDER_QUALITY_SUCCESS:
            return {
                ...state,
                saveCarOrderQualityResponse: action.payload,
            }

        default:
            return state
    }
}
